import { IconProps } from './IconProps';

export const CartCross = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill="#F2F2F7" />
      <path
        d="M10.0474 18.1821C9.73633 18.4931 9.72998 19.0454 10.0537 19.3691C10.3838 19.6928 10.936 19.6865 11.2407 19.3818L14.9985 15.624L18.75 19.3755C19.0674 19.6928 19.6133 19.6928 19.937 19.3691C20.2607 19.039 20.2607 18.4995 19.9434 18.1821L16.1919 14.4306L19.9434 10.6728C20.2607 10.3554 20.2671 9.80949 19.937 9.48579C19.6133 9.16209 19.0674 9.16209 18.75 9.47949L14.9985 13.2309L11.2407 9.47949C10.936 9.16839 10.3774 9.15569 10.0537 9.48579C9.72998 9.80949 9.73633 10.3681 10.0474 10.6728L13.7988 14.4306L10.0474 18.1821Z"
        fill="#3C3C43"
        fill-opacity="0.6"
      />
    </svg>
  );
};

